//Core module
import React from 'react';

//External module
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import cx from "classnames";
import {Button} from "reactstrap";

//Internal module
import '../../Legacy/assets/legacy.css';
import requestApi from "../../../services/requestApi.service";
import {handleErrorResponse, showToast} from "../../../Common/Appcommon";
import ListTable from "../../../Common/ListTable";

class FbAccountList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            accountList : {}
        }
    }

    componentDidMount() {
        this.getConnectedAccounts();
    }

    getConnectedAccounts = async () => {
        let params = {
            "ENTITY": "FACEBOOK",
            "OPERATION" : 'GETALL'
        }
        let response = await requestApi.processServerRequest(params);

        if(response.issuccess){
            let {accountList} = this.state;
            accountList = response.data;
            this.setState({accountList});
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    connectFaceBook = async () => {
        let params = {
            "ENTITY": "FACEBOOK",
            "OPERATION" : 'Connect',
            "wpApp" : true
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            window.location = response.data[0];
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    removeAccount = async (formid) => {
        if(formid !== undefined && formid !== "" && formid !== null){
            let params = {
                "ENTITY": "FACEBOOK",
                "OPERATION" : 'DELETEACCOUNT',
                "recordid" : formid
            }
            let response = await requestApi.processServerRequest(params);

            if(response.issuccess){
                showToast(`Account Removed Successfully`);
            }else{
                handleErrorResponse(response.errormsg);
            }
            this.getConnectedAccounts();
        }
    }

    renderElements = (name,formData,field) => {

        if(name === 'status'){
            const val =  (formData['2'] !== undefined && formData['2'] === "1") ? 'Connected' : 'Not Connected';
            return <div>{val}</div>;
        }else if(name === 'remove'){
            const id = formData['0'] !== undefined ? formData['0'] : '';
            return <div className={`le-clickable`} onClick={()=>{this.removeAccount(id)}}>{`remove`}</div>
        }
    }

    render() {

        let {accountList} = this.state;

        let listFields = [['Account Name','Status','Remove'],['4','2','0']];

        let customFieldConfig = {
            '2': {
                "render": "status"
            },
            '0' : {
                "render": "remove"
            }
        };

        return (
            <>

                <div className={`d-flex`}>
                    <div className={'cursor-pointer ml-2 mb-2'} onClick={(e) => {this.props.onBackAction(e)}}>
                        <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                    </div>
                    <Button onClick={this.connectFaceBook} className={cx("m-1 me-2 mt-2 mr-2 btn-icon le-button lePrimaryBtn")}>
                        {`Connect Facebook Account`}
                    </Button>
                </div>
                <div className={`offset-3 col-6 mt-3 mb-5`}>
                    <div className={`offset-3 fb-account-title mb-2`}>
                        Connected Facebook Account List
                    </div>
                    <ListTable
                        key={Math.random()}
                        formData={accountList}
                        fields={listFields}
                        showRowCount={true}
                        spaceBfCell={false}
                        config={customFieldConfig}
                        renderElements={this.renderElements}
                        noDataMsg={`Accounts not found`}
                        prefix = {"fb_account"}
                        customClass={'no-border-table'}
                        formName={'table_3'}
                    />
                </div>
            </>

        );
    }
}

export default FbAccountList;
